import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './ClothingSizes';

const ClothingSizesSuspense = dynamic(() => import('./ClothingSizes'), {
	loading: () => <BlockLoadingSpinner />,
});

export default function DynamicClothingSizes(props: Props) {
	return <ClothingSizesSuspense {...props} />;
}
DynamicClothingSizes.displayName = 'DynamicClothingSizes';
